//@flow
import React from 'react';
import slugify from '@sindresorhus/slugify';
import { Link, withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { LodgeSearchForm } from '../Common';

import { 
  UVP,
  Page,
  TrekCard,
  LodgeCard,
  CardsSlider,
  FullReview,
  SideReview,
  FeaturedPlacesSlider,
} from '../../../components';
import PLACE_NAMES from '../../../constants/places';
import { appendHoneyGuide } from '../../../lib/utils';
// import CoronaVirusNotice from './CoronaVirusNotice';
import reviews from './lodgeReviews.json';
import uvpData from './uvpData';

const subText = 'With 800+ properties, the Largest Hotel Listing in the Himalayas.';
const title = 'Book Lodges in the Everest and Annapurna Region';

const bgImages = 'url(https://s3.amazonaws.com/honeyguide/assets/lodge-bg.jpg)';

const SearchLodgesScreen = () => (
  <Page title={appendHoneyGuide(title)} description={subText}>
    <Container fluid={true} className="mt--1">
      <Row>
        <div className="container-bg" style={{ backgroundImage: bgImages }}>
          <Container className="full-height flex-with-center flex-column">
            <div className="search-panel">
              <h1 className="ft-page-title">{title}</h1>
                <p className="sub">{subText}</p>
              <div className="SearchForm">
                <LodgeSearchForm />
              </div>
            </div>
            <SliderPlaceLists />
          </Container>
          {/* <CoronaVirusNotice /> */}
        </div>
      </Row>
    </Container>
    <Container>
      <Row>
        {/* <CoronaVirusNotice onMobile/> */}
        <UVP data={uvpData} />
      </Row>
      <Row className="find-lodge">
        <Col xs={{size: 12, order:2}} lg={{size: 8, order: 1}}>
          <CardsSlider
            title="Featured Lodges"
            endpoint="lodgings/lodges?is_featured=1"
            Card={LodgeCard}
            showNoOfCards={3}
            keysToFilterOut={['b671c1490341']}
          />
          <FeaturedPlacesSlider dataKey="EBC" />
          <FeaturedPlacesSlider dataKey="GOKYOLAKES" />
          <FeaturedPlacesSlider dataKey="THREEPASSES" />
          <FeaturedPlacesSlider dataKey="ABC" />
          <FeaturedPlacesSlider dataKey="ACT" />
          <CardsSlider
            title="Check out these Itineraries for Recommended Stops:"
            endpoint="trips/treks?is_featured=1"
            Card={TrekCard}
            showNoOfCards={3}
          />
          <FullReview sectionId="fullReviewsSection" reviews={reviews} />
          <FullReview isMobile sectionId="fullReviewsSection" reviews={reviews} />
        </Col>
        <Col xs={{size: 12, order: 1}} lg={{size: 4, order: 2}}>
          <SideReview fullReviewsSectionId="#fullReviewsSection" reviews={reviews} />
          <SideReview fullReviewsSectionId="#fullReviewsSection" reviews={reviews} isMobile />
        </Col>
      </Row>
    </Container>
  </Page>
);
    
const settings = {
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    swipe: true,
    dots: false,
    arrows: false,
    speed: 1500,
    centerPadding: '20px',
    rows: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {infinite: false, slidesToShow: 8, slidesToScroll: 1 },
  },
    {
      breakpoint: 1024,
      settings: {infinite: false, slidesToShow: 8, slidesToScroll: 1 },
  },
    {breakpoint: 991, settings: {slidesToShow: 6, slidesToScroll: 1 } },
    {breakpoint: 750, settings: {slidesToShow: 4, slidesToScroll: 1 } },
    {breakpoint: 500, settings: {slidesToShow: 3, slidesToScroll: 1 } },
  ],
};

const SliderPlaceLists = withRouter(({location}) => (
  <div className="slider-wraper">
      <h5>Popular searches</h5>
      <Slider {...settings} className="place-name">
        {PLACE_NAMES.map(({ name, id, region }) => (
          <div key={id} className="place-holder">
            <Link
              key={id}
              to={{
                pathname: location.pathname,
                search: `?placeId=${id}&placeName=${slugify(name)}&region=${region}`,
              }}
            >{name}</Link>
          </div>
        ))}
      </Slider>
    </div>
    ));
    
    export default SearchLodgesScreen;



// WEBPACK FOOTER //
// ./src/screens/Lodge/Search/SearchLodgesScreen.js